import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import logo from './../../../assets/images/logo.png';
import css from './Footer.module.css';
import { Link } from 'react-router-dom';
import orn from './../../../assets/images/ornament.svg';
import axios from 'axios';

function SiteFooter(props) {
    let [visits, setVisits] = useState(0);

    useEffect(() => {
        axios.get('visits').then(res => {
            setVisits(res.data)
        });
    }, []);

    return (
        <footer>
            <div className={css.sfoot} style={{
                backgroundImage: 'url(' + orn + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }}>
                <Row>
                    <Col md={4}>
                        <img src={logo} alt="" />
                        <h4 className='mt-3'>FamilyBook.uz</h4>
                        <p>Onlayn kitob o'qish platformalari o'quvchilarga kitoblarni smartfon, planshet yoki kompyuter orqali o'qish imkonini beradi. </p>
                        <Stack direction="horizontal" gap={2} className='p-2'>
                            <Link className={css.sociallinks} to="/"><i className={css.socialicons + " bi bi-facebook"}></i></Link>
                            <Link className={css.sociallinks} to="/"><i className={css.socialicons + " bi bi-telegram"}></i></Link>
                            <Link className={css.sociallinks} to="/"><i className={css.socialicons + " bi bi-youtube"}></i></Link>
                            <Link className={css.sociallinks} to="/"><i className={css.socialicons + " bi bi-twitter-x"}></i></Link>
                        </Stack>
                        <h6>Jami tashrif buyurganlar: {visits.value} nafar</h6>
                    </Col>
                    <Col md={3}>
                        <h3>Foydali sahifalar</h3>
                        <ul className={css.footlinks}>
                            <li><Link to="/">Bosh sahifa</Link></li>
                            <li><Link to="/books">Kitoblar</Link></li>
                            <li><Link to="/music">Audio kitoblar</Link></li>
                            <li><Link to="/privacy">Sayt qonun-qoidalari</Link></li>
                            <li><Link to="/about">Biz haqqimizda</Link></li>
                        </ul>
                    </Col>
                    <Col md={5}>
                        <h3>Manzillarimiz</h3>
                        <ul className={css.footlinks}>
                            <li className={css.finfo}><i className="bi bi-telephone"></i> Telefon: <a href="tel:+998995985504">+99899 598-55-04</a></li>
                            <li className={css.finfo}><i className="bi bi-envelope"></i> Email: <a href="mailto:n.rustamova@umail.uz"> n.rustamova@umail.uz</a></li>
                            <li className={css.finfo}><i className="bi bi-geo-alt"></i> Haritada: <a href="https://maps.app.goo.gl/xWhTJtukMBfKVznc9" target='_blank' rel="noreferrer noopener"> Samarqand, Buyuk Ipak yo'li, 131</a></li>
                        </ul>
                    </Col>
                </Row>
            </div>
        </footer>

    );
}

export default SiteFooter;